import { useEffect } from 'react';

const PageEffects = () => {
  useEffect(() => {
    // Scroll progress bar
    const scrollBar = document.getElementById('scroll-bar');
    const cursorGlow = document.getElementById('cursor-glow');

    const handleScroll = () => {
      if (scrollBar) {
        const h = document.documentElement.scrollHeight - window.innerHeight;
        scrollBar.style.width = h > 0 ? `${(window.scrollY / h) * 100}%` : '0%';
      }
    };

    const handleMouse = (e) => {
      if (cursorGlow) {
        cursorGlow.style.left = e.clientX + 'px';
        cursorGlow.style.top = e.clientY + 'px';
      }
    };

    // Intersection Observer for reveals
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.reveal, .reveal-left').forEach(el => observer.observe(el));

    // Stat counter animation
    const statObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('[data-count]').forEach(el => {
            const target = parseInt(el.dataset.count, 10);
            const duration = 2000;
            const start = performance.now();
            const easeOut = t => 1 - Math.pow(1 - t, 3);
            const animate = (now) => {
              const progress = Math.min((now - start) / duration, 1);
              el.textContent = Math.round(easeOut(progress) * target);
              if (progress < 1) requestAnimationFrame(animate);
            };
            requestAnimationFrame(animate);
          });
          statObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    const statsEl = document.querySelector('[data-stats]');
    if (statsEl) statObserver.observe(statsEl);

    // 3D tilt on property/category cards
    const handleCardTilt = (e) => {
      const card = e.currentTarget;
      const rect = card.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = `perspective(800px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) translateY(-4px)`;
    };
    const handleCardReset = (e) => {
      e.currentTarget.style.transform = '';
    };

    document.querySelectorAll('[data-tilt]').forEach(card => {
      card.addEventListener('mousemove', handleCardTilt);
      card.addEventListener('mouseleave', handleCardReset);
    });

    // Location card sequential glow
    const locObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const cards = entry.target.querySelectorAll('.loc-card');
          let idx = 0;
          const glow = () => {
            cards.forEach(c => c.classList.remove('active-glow'));
            if (cards[idx]) cards[idx].classList.add('active-glow');
            idx = (idx + 1) % cards.length;
          };
          glow();
          const interval = setInterval(glow, 2000);
          return () => clearInterval(interval);
        }
      });
    }, { threshold: 0.3 });

    const locSection = document.querySelector('[data-loc-section]');
    if (locSection) locObserver.observe(locSection);

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouse);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouse);
      observer.disconnect();
      statObserver.disconnect();
      locObserver.disconnect();
      document.querySelectorAll('[data-tilt]').forEach(card => {
        card.removeEventListener('mousemove', handleCardTilt);
        card.removeEventListener('mouseleave', handleCardReset);
      });
    };
  }, []);

  return null;
};

export default PageEffects;
